module.exports = __webpack_public_path__ + "media/da_dk_s1_Grete.bb0cfdcb.mp3";